import { FC } from 'react';
import {
  Box,
  Typography,
  ButtonBase,
  Stack,
  useMediaQuery,
} from '@mui/material';

export interface ArticleCardProps {
  fullWidth?: boolean;
  title: string;
  description: string;
  shortDescription: string;
  image: string;
  link: string;
}

const ArticleCard: FC<ArticleCardProps> = ({
  title,
  description,
  shortDescription,
  image,
  link,
  fullWidth,
}) => {
  return (
    <Stack
      spacing={{
        xs: '16px',
        md: fullWidth ? '0px' : '16px',
      }}
      sx={{
        flexDirection: {
          xs: 'column',
          md: fullWidth ? 'row' : 'column',
        },
        alignItems: 'flex-start',
        width: {
          xs: 'auto',
          sm: '100%',
        },
        height: {
          xs: 'auto',
          sm: 'auto',
        },
        justifyContent: {
          xs: 'flex-start',
          md: fullWidth ? 'space-between' : 'flex-start',
        },
        marginBottom: {
          xs: 'auto',
          sm: '60px',
          md: 'auto',
        },
      }}
    >
      <Box
        sx={{
          width: {
            xs: '100%',
            md: fullWidth ? 'calc(100% - 70px - 514px)' : '100%',
          },
          height: {
            xs: '342px',
            sm: '342px',
            md: '400px',
          },
          overflow: 'hidden',
          marginRight: { xs: 0, md: fullWidth ? '70px' : 0 },
          minWidth: fullWidth ? '0' : undefined,
          display: 'block',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Stack
        direction="column"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          width: { xs: 'auto', md: fullWidth ? '514px' : '100%' },
          height: {
            xs: 'auto',
            sm: 'auto',
            md: fullWidth ? '400px' : 'auto',
          },
        }}
      >
        <Stack
          direction="column"
          spacing={'12px'}
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            maxWidth: {
              sm: '100%',
              md: '400px',
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: '#CDFF6F',
              borderRadius: '18px',
              padding: '8px 17px',
              minHeight: '36px',
              fontWeight: 500,
              fontSize: {
                xs: '14px',
                sm: '16px',
                md: '16px',
              },
              color: '#38383B',
              display: 'inline-block',
            }}
          >
            Keyword of the article
          </Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: {
                xs: '24px',
                sm: '24px',
                md: '35px',
              },
              height: {
                xs: '64px',
                sm: '64px',
                md: fullWidth ? '90px' : '135px',
              },
              color: '#38383B',
              maxWidth: '514px',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              lineHeight: '130%',
              letterSpacing: '-0.02em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: { xs: 2, sm: 2, md: fullWidth ? 2 : 3 },
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'normal',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              fontSize: '16px',
              color: '#38383B80',
              lineHeight: '130%',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              fontFamily: 'Schibsted Grotesk',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: { xs: 3, sm: 3, md: fullWidth ? 5 : 4 },
            }}
            align="left"
          >
            {shortDescription}
          </Typography>
        </Stack>
        <Box
          sx={{
            paddingTop: {
              xs: '30px',
              sm: '18px',
              md: '30px',
            },
          }}
        >
          <ButtonBase
            href={link}
            sx={{
              justifyContent: 'flex-start',
              textDecoration: 'underline',
              textDecorationColor: '#238AFF',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: {
                  xs: '14px',
                  sm: '20px',
                  md: '20px',
                },
                color: '#238AFF',
                fontFamily: 'Schibsted Grotesk',
              }}
            >
              Read more →
            </Typography>
          </ButtonBase>
        </Box>
      </Stack>
    </Stack>
  );
};

export default ArticleCard;
